import { IPricingElements } from './home-screen';

export const DEFAULT_LOGO_IMAGE = 'https://ik.imagekit.io/torimapp/no-image_OU9SfsTMS.png';

export const customersTestimonials: Array<{ name: string; business: string; imgUrl: string; review: string; }> = [
  {
    business: 'The Lashes Fairy',
    name: 'מעין',
    imgUrl: 'https://ik.imagekit.io/torimapp/the_pashes_fairy-c7a5fa1f-b8c8-45e1-ace6-701905362262_rv7IZIxPU.jpg',
    review: 'האפליקציה נוחה בטירוף. עצם העובדה שגם התורים וגם הקבלות זה מאותה אפליקציה זה ממש משנה חיים והלקוחות נותנות לי כול הזמן פידבקים חיובים ואומרות שזה ממש נוח. וגםםם הנראות שלך האפליקציה! שלמות! אם יש משהו שחשוב לי זה אסטטיות והנראות של אפליקציה אסטטית ומושכת לגמרי'
  },
  {
    business: 'Sapir Azulai Beauty',
    name: 'ספיר אזולאי',
    imgUrl: 'https://ik.imagekit.io/torimapp/sapir_azulai-f6d3ca43-13b4-4644-b0ad-af39495ea671_JzeNt2bH-.jpg',
    review: 'חייבת להגיד שטיים איט אפליקציה מדהימה נגישה וקלה לעבודה! לאפליקציה יש צוות תמיכה ושירות מהיר עד השעות המאוחרות של הלילה,שירות מכל הלב ואכפתי!  האפליקציה חוסכת לי המון זמן עבודה ומפנה לי זמן פנוי לעצמי! תודה רבה לכם❤️'
  },
  {
    business: 'Rachel Dayan Nails',
    name: 'רחלי',
    review: 'קודם כל האפליקציה  מאוד נגישה  ונוחה ויש מלא פונקציות מועילות שמקלות עלי בקביעת התורים, אני אישית אף פעם לא השתמשתי באפליקציה כלשהי לקביעת תורים ואני שמחה שעשיתי את זה עם טיימאיט כי אני מאוד מרוצה \n' +
      'והשירות מעולה, ותמיד זמינים לי לכל שאלה ובעיה',
    imgUrl: 'https://ik.imagekit.io/torimapp/368140443_1008617706945853_3480259745203908081_n_vR4xxBHF9.jpg'
  },
  {
    business: 'Amit Tako',
    name: 'עמית טאקו',
    review: '',
    imgUrl: 'https://ik.imagekit.io/torimapp/amit_tako-ca635780-b624-4386-aacd-0cce82b7465d_iN_yhUlMK.jpg'
  },
  {
    business: 'Bell Skin Care',
    name: 'בל',
    review: 'אני חייבת לפרגן לחברת Time It מאז שהתחלתי לעבוד עם הממשק שלהם ניהול היומן שלי השתדרג לגמרי. הכל נמצא בממשק אחד מסודר וברור כולל זימון תורים,תזכורות אוטומטיות, קבלות חיובים ופרטים מלאים על הלקוחות.  זה חוסך לי המון זמן, מונע טעויות ועושה לי סדר אמיתי בעסק. מעבר למערכת עצמה, השירות לקוחות שלהם פשוט מעולה. תמיד עונים מהר ,מטפלים בכל פניה, מקשיבים לכל בקשה ומשתדלים באמת למצוא פתרון שמתאים לעסק שלי. מרגיש שיש עם מי לדבר ויש גב אמיתי מאחורי המערכת. ממליצה בחום לכל בעל/ת עסק שרוצים לעבוד מסודר יעיל ובראש שקט 🙏🏻',
    imgUrl: 'https://ik.imagekit.io/torimapp/belle_microblading-122bf87a-6061-412b-990a-3dc20e051a90_ZxrJa-5YY.jpg'
  },
  {
    business: 'Lashes by Shirel',
    name: 'שיראל',
    review: '',
    imgUrl: 'https://ik.imagekit.io/torimapp/lashes_by_shirel-d1a94695-93ce-4ca6-b762-9c15125887f5_LZP-9yM6t.jpg'
  },
  {
    business: 'המרגש',
    name: 'עידו',
    review: '',
    imgUrl: 'https://ik.imagekit.io/torimapp/hameragesh-9957ce74-4d73-47b7-adff-ed6a169779ce_boLA_e3Zq.jpg'
  },
  {
    business: 'ילי אנגל',
    name: 'ילי אנגל',
    review: '',
    imgUrl: 'https://ik.imagekit.io/torimapp/yali_engel_chinese_medicine-5032b9db-c70f-49cb-a9fc-19e912b01e67_lUwYbWXyK.jpg'
  },
  {
    business: 'זהבה רחמים',
    name: 'זהבה רחמים',
    review: '',
    imgUrl: 'https://ik.imagekit.io/torimapp/zehava_rachamim-7ddb540d-a9a4-442d-b66e-608d038eb513_bNXt9sP4p.jpg'
  }
];

export const pricingElements: Array<IPricingElements> = [
  {
    price: 'חינם',
    priceYearly: 'חינם',
    bgColor: 'orange',
    chip: '#משתדרגים_בחינם',
    description: 'לעסקים קטנים בתחילת הדרך',
    items: [
      'דף נחיתה וניהול יומן דיגיטלי',
      'קביעת תורים ללקוחות - עד 25 תורים וללא הגבלת לקוחות',
      'תזכורות אוטומטיות ואישורי הגעה',
      'ניתוח נתונים וסטטיסטיקות',
      '100 הודעות SMS',
      'רשימת המתנה',
      'תמיכה טכנית ושירות לקוחות במייל'
    ],
    type: 'regular'
  },
  {
    price: '119 / לחודש*',
    priceYearly: '99 / לחודש*',
    bgColor: 'purple',
    chip: '#הכל_כלול',
    description: 'כל מה שהעסק שלך צריך בחבילה אחת',
    items: [
      'ללא הגבלת תורים ולקוחות',
      'הודעות תפוצה ללקוחות והודעות אוטומטיות',
      '1000 הודעות SMS',
      'מערכת ניהול לעובדים',
      'תמיכה טכנית ושירות לקוחות במייל ובווטסאפ'
    ],
    type: 'selected'
  }
];

export const questionsAndAnswers: Array<{ question: string; answer: string; value: string; }> = [
  {
    question: 'האם האפליקציה בחינם?',
    answer: 'כן, האפליקציה זמינה בשני מסלולים: מסלול חינמי אשר מוגבל בחלק מהיכולות והינו מתאים לעסקים בתחילת הדרך, ויש את מנוי הפרימיום "הכל כלול" אשר מתאים לעסקים מתקדמים וכולל את כל היכולות של האפליקציה ולכן הינו בתשלום. הבחירה בין מסלול חינם למסלול פרימיום תלויה בצרכים שלכם. אם אתם עסק בתחילת הדרך, מסלול החינם יכול להיות מספיק עבורכם. עם זאת, אם אתם זקוקים לתכונות מתקדמות יותר, תצטרכו לשדרג למסלול הפרימיום.',
    value: '0'
  },
  {
    question: 'האם יש תקופת ניסיון בחינם למנוי הפרימיום "הכל כלול" לראות שזה מתאים לי?',
    answer: 'כמובן, בעת ההרשמה לאפליקציה אנו מעניקים 14 ימי ניסיון ללא התחייבות וללא פרטי אשראי למנוי הפרימיום "הכל כלול" שלנו. כלומר, ברגע ההרשמה כל היכולות של האפליקציה יהיו פתוחות ולאחר 14 יום תועברי באופן אוטומטי למסלול החינמי.',
    value: '1'
  },
  {
    question: 'האם ניתן לבטל את המנוי?',
    answer: 'מסלול חודשי - אין התחייבות לתקופה מסויימת ולכן ניתן לבטל את המנוי.  מסלול שנתי - לא ניתן לביטול.',
    value: '2'
  },
  {
    question: 'האם האפליקציה מיועדת לניהול העסק או לזימון התורים ללקוחות שלי?',
    answer: 'האפליקציה מיועדת גם בשבילך וגם בשביל הלקוחות הקבועות שלך. על מנת להיכנס לפאנל הניהול דרך האפליקציה לחצי מטה על כפתור "התחברות לפאנל ניהול העסק".',
    value: '3'
  },
  {
    question: 'האם הלקוחות שלי חייבות להוריד את האפליקציה? ',
    answer: 'לא, כל הלקוחות שלך יוכלו לזמן תור ישירות דרך הקישור לדף הנחיתה שאותו את משתפת 😊. האפליקציה שלנו מיועדת ללקוחות הקבועות שלך כדי שיוכלו להיכנס ולהזמין תור בקלילות ובמהירות.',
    value: '4'
  },
  {
    question: 'האם ניתן לקבל תשלומים מלקוחות ולהפיק חשבוניות דרך האפליקציה?',
    answer: 'ברור, זו המטרה שלנו! אנחנו רוצים להקל עלייך ולעזור לך לנהל הכל במקום אחדו, לכן הוספנו את האפשרות לחבר סליקה וחשבוניות לאפליקציה!',
    value: '5'
  },
  {
    question: 'האם הלקוחות שלי מקבלות הודעות תזכורת ואישורי הגעה?',
    answer: 'כמובן! כל הלקוחות יקבלו הודעות תזכורות לפני התור בין 24-72 שעות, את יכולה לבחור בעצמך דרך הגדרות לזימון תורים ;)',
    value: '6'
  }
];

export interface FeatureBox {
  name: string;
  icon: string;
  gradient: string;
  // tagline: string;
  shortDescription: string;
  // keyBenefits?: Array<{ icon: string; text: string }>;
  // // heroImage: string;
  // howItWorksDescription: string;
  // steps: Array<{
  //   icon: string;
  //   title: string;
  //   description: string;
  // }>;
  // demoDescription?: string;
  // screenshots?: Array<{
  //   image: string;
  //   title: string;
  //   description: string;
  // }>;
  // detailedBenefits?: Array<{
  //   icon: string;
  //   title: string;
  //   description: string;
  //   stat: string;
  // }>;
  // faqs?: Array<{
  //   question: string;
  //   answer: string;
  // }>
}

export const features: Record<string /**slug**/, FeatureBox> = {
  'smart-booking': {
    name: 'זימון תורים חכם',
    icon: '📅',
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    shortDescription: 'הלקוחות קובעים ומעדכנים תורים בעצמם 24/7'
  },
  'crm': {
    name: 'מערכת CRM לניהול לקוחות',
    icon: '👥',
    gradient: 'linear-gradient(135deg, #43cea2 0%, #185a9d 100%)',
    shortDescription: 'כל מה שצריך לדעת על הלקוחות שלך – מרוכז ונגיש בלחיצת כפתור.'
  },
  'whatsapp-integration': {
    name: 'חיבור ל-Whatsapp',
    icon: '💬',
    gradient: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)',
    shortDescription: 'תקשורת ישירה עם הלקוחות בערוץ הכי נוח להם.'
  },
  'customer-loyalty': {
    name: 'מועדון לקוחות',
    icon: '💎',
    gradient: 'linear-gradient(135deg, #f7971e 0%, #ffd200 100%)',
    shortDescription: 'תוכנית נאמנות שמתגמלת לקוחות ומעודדת חזרה.'
  },
  'vouchers': {
    name: 'ניהול שוברים',
    icon: '🎟️',
    gradient: 'linear-gradient(135deg, #ff6a00 0%, #ee0979 100%)',
    shortDescription: 'מוכרים ומנהלים שוברים דיגיטליים בקלות.'
  },
  'pickup-store': {
    name: 'חנות פיקאפ אונליין',
    icon: '🛒',
    gradient: 'linear-gradient(135deg, #fc4a1a 0%, #f7b733 100%)',
    shortDescription: 'הלקוחות מוסיפות מוצרים לעגלה במהלך הזמנת טיפול.'
  },
  'complementary-services': {
    name: 'שירותים נוספים בקליק',
    icon: '🛍️',
    gradient: 'linear-gradient(135deg, #fc4a1a 0%, #f7b733 100%)',
    shortDescription: 'מאפשר ללקוחות להוסיף טיפולים נלווים או שדרוגים תוך כדי הזמנת התור'
  },
  'payment-invoicing': {
    name: 'תשלום וחשבוניות',
    icon: '💳',
    gradient: 'linear-gradient(135deg, #00c6ff 0%, #0072ff 100%)',
    shortDescription: 'גובים תשלום ושולחים קבלות בלחיצת כפתור.'
  },
  'reviews': {
    name: 'איסוף ביקורות',
    icon: '⭐',
    gradient: 'linear-gradient(135deg, #f7971e 0%, #ffd200 100%)',
    shortDescription: 'שולחים בקשת ביקורת אוטומטית אחרי טיפול.'
  }
};


export const keyFeatures: Array<{
  icon: string;
  title: string;
  description: string;
  slug: string;
}> = Object.entries(features).map(([key, value]) => ({
  slug: key,
  icon: value.icon,
  description: value.shortDescription,
  title: value.name
}));
